module.exports = __webpack_public_path__ + "img/redo.1f7ad062.svg";